exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".perf-tool .features{text-align:center}.perf-tool .feature{border-bottom:1px solid #ddd;padding:.3em;text-align:left}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/styles/features.css
 ** module id = 208
 ** module chunks = 0
 **/